import { IAddress } from 'types';

export function readableAddress(addressProps?: IAddress): string[] {
  if (!addressProps || !addressProps?.address) {
    return [];
  }

  const {
    isManual, address, addressLineOne, addressLineTwo, city, postCode, region, country,
  } = addressProps;

  if (!isManual) {
    return address.description.split(',');
  }

  return [
    addressLineOne || '',
    addressLineTwo || '',
    city?.name || '',
    postCode || '',
    region?.name || '',
    country || '',
  ];
}
